/**
 * Buy More Save More Section JavaScript
 * Handles the functionality of the Buy More Save More section
 */

const jqDoc = $(document)
const s = $('body')
const addLoadingClass = 'is--loading'
const html_data = {}

const unavailable = window.T4SProductStrings.unavailable
const soldOut = window.T4SProductStrings.soldOut
const addText = window.T4SProductStrings.addToCart
function n() {
  var t = $('.t4s-product-quick-shop:not(.' + this.te + ')')
  t.addClass(this.te),
    new T4SThemeSP.Product(t[0]),
    T4SThemeSP.PopupMFP(),
    window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
    T4SThemeSP.Wishlist.updateAll(),
    T4SThemeSP.Compare.updateAll(),
    T4SThemeSP.ProductItem.reloadReview(),
    T4SThemeSP.Tooltip(),
    s.trigger('currency:update')
}

function getSectionInnerHTML(html, selector) {
  return (
    new DOMParser().parseFromString(html, 'text/html').querySelector(`#${selector}`)?.innerHTML ||
    ''
  )
}

function regBtn(type) {
  $('.t4s-modal--is-active .lt-add').on('click', function (e) {
    e.preventDefault()
    const container = $(this).closest('.t4s-product-form__variants')
    const form = container.find('form').get(0)
    const data = new FormData(form)
    const allData = JSON.parse(container.find('.pr_variants_json').html())
    const item = allData.find(item => item.id == data.get('id'))

    const info = {
      id: item.id,
      quantity: data.get('quantity'),
      pid: data.get('product-id'),
      price: item.price,
      img: item.featured_image?.src || container.data('img'),
      type,
    }
    jqDoc.trigger('lute:match:add', info)
    s.trigger('modalt4s:closed')
  })

  $('[data-product-featured]').on('variant:changed', function (e) {
    const t = e.currentVariant
    var i = $(this).find('.lt-add')
    var a = $(this).find('[data-quantity-wrapper]')
    var o = i.find('.t4s-btn-atc_text')
    if (!i.length) return
    if (
      (T4SThemeSP.isEditCartReplace &&
        !i.is('[data-replace-item]') &&
        i.attr('data-replace-item', ''),
      t && 'nathan' != t)
    ) {
      if (t.available) {
        a.show()
        i.removeAttr('disabled aria-disabled')
        o.text(addText)
      } else {
        a.hide()
        i.attr('disabled', 'disabled').attr('aria-disabled', !0)
        o.text(soldOut)
      }
    } else {
      i.attr('disabled', 'disabled').attr('aria-disabled', !0)
      o.text(unavailable)
      a.hide()
    }
  })
}

function genRandomId() {
  return 'id-' + Math.random().toString(36).substr(2, 9)
}

class BuyMoreSaveMore {
  constructor(section) {
    this.container = section.querySelector('.bmsm-container')
    this.flag = this.container.dataset.flag || 'default'
    this.te = 'initProducts__enabled'
    this.addLoadingClass = 'is--loading'
    this.section = section
    this.addButtons = section.querySelectorAll('.bmsm-add-btn')
    this.selectedText = section.querySelector('.match-bar .selected')
    this.selectedTemp = section.querySelector('#bmsm-select-text').content
    this.steps = section.querySelectorAll('.match-bar .step .item')
    this.discountText = section.querySelector('.match-bar .discount-text')
    this.addToCartButton = section.querySelector('.cart-btn')
    this.swiperImgs = section.querySelector('.match-bar .imgs .swiper')
    this.emptyEl = section.querySelector('.match-bar .imgs .empty')

    this.cartItemsContainer = this.swiperImgs.querySelector('.swiper-wrapper')
    this.selectedItems = []
    this.matchSwiper = null

    console.log('🚀 ~ this.container.dataset:', this.container.dataset)
    this.discount3 = this.container.dataset['discount-3'] || 0
    this.discount4 = this.container.dataset['discount-4'] || 0

    this.loadPage = 2
    this.loadMorePagination = section.querySelector('.t4s-prs-pagination')
    if (this.loadMorePagination) {
      this.loadMoreBtn = this.loadMorePagination.querySelector('.t4s-loadmore-btn')
      this.sectionId = this.loadMoreBtn.dataset.sectionId
      this.path = this.loadMoreBtn.dataset.path
      this.total = this.loadMoreBtn.dataset.total
      this.loadMoreBar = this.loadMorePagination.querySelector('.t4s-lm-bar--current')
      this.currentPageEl = this.loadMorePagination.querySelector('[data-current-bar]')
    }
    this.productContainer = section.querySelector('.bmsm-products')
    this.init()
  }

  init() {
    this.addEventListeners()
    this.initSection()
    jqDoc.on('lute:match:add', (e, item) => {
      if (item.type !== this.flag) return
      const appendItems = []
      if (item.quantity > 1) {
        const count = item.quantity
        for (let i = 0; i < count; i++) {
          const newItem = { ...item, quantity: 1, eid: genRandomId() }
          appendItems.push(newItem)
        }
      } else {
        const newItem = { ...item, eid: genRandomId() }
        appendItems.push(newItem)
      }
      this.selectedItems.push(...appendItems)

      this.updateSection(appendItems)
    })
  }

  updateLocalStorage() {
    localStorage.setItem(`LUTE:BMSM:${this.flag}`, JSON.stringify(this.selectedItems))
  }

  initSection() {
    const data = localStorage.getItem(`LUTE:BMSM:${this.flag}`)
    this.selectedItems = data ? JSON.parse(data) : []
    if (this.selectedItems.length > 0) {
      this.initSwiper()
      this.handleAddSlide(this.selectedItems)
      this.handleTextChange()
      this.handleDotChange()
    }
  }

  updateSection(arr, type = 'add') {
    this.initSwiper()
    if (arr && arr.length > 0) {
      if (type === 'remove') {
        this.handleRemoveSlide(arr)
      } else {
        this.handleAddSlide(arr)
      }
    }

    this.handleTextChange()
    this.handleDotChange()
    this.updateLocalStorage()
  }

  initSwiper() {
    const count = this.selectedItems.length

    if (count === 0) {
      this.emptyEl.classList.remove('hidden')
      this.swiperImgs.classList.add('hidden')
    } else {
      this.emptyEl.classList.add('hidden')
      this.swiperImgs.classList.remove('hidden')
    }
    if (count > 0 && !this.matchSwiper) {
      this.matchSwiper = new Swiper(this.swiperImgs, {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        navigation: {
          nextEl: '.match-next-btn',
          prevEl: '.match-prev-btn',
        },
      })
    }
  }

  handleAddSlide(arr) {
    const data = arr.map(item => {
      return `<div class="swiper-slide img"  data-id="${item.eid}">
          <img src="${item.img}" alt="">
          <div class="close-icon">
            <svg viewBox="0 0 36 36">
              <use xlink:href="#match-close"></use>
            </svg>
          </div>
        </div>`
    })
    this.matchSwiper.appendSlide(data)
    this.matchSwiper.slideTo(this.matchSwiper.slides.length - 1)
  }

  handleRemoveSlide(idx) {
    this.matchSwiper && this.matchSwiper.removeSlide([idx])
  }

  addCartEvent(btns) {
    let that = this
    // Add product buttons
    if (btns) {
      btns.forEach(button => {
        button.classList.add('watched')
        button.addEventListener('click', e => that.handleAddProduct(e))
      })
    }
  }

  addEventListeners() {
    const addButtons = this.section.querySelectorAll('.bmsm-add-btn')
    this.addCartEvent(addButtons)
    // Remove item buttons
    if (this.cartItemsContainer) {
      this.cartItemsContainer.addEventListener('click', e => {
        if (e.target.classList.contains('close-icon')) {
          this.handleRemoveItem(e)
        }
      })
    }

    this.addToCartButton.addEventListener('click', e => {
      this.handleAddToCart(e)
    })

    this.loadMoreBtn &&
      this.loadMoreBtn.addEventListener('click', e => {
        this.handleLoadMore(e)
      })
  }

  updateEvents() {
    T4SThemeSP.reinitProductGridItem()
    const addButtons = this.section.querySelectorAll('.bmsm-add-btn:not(.watched)')
    this.addCartEvent(addButtons)
  }

  handleAddProduct(e) {
    e.preventDefault()
    e.stopPropagation()
    const button = e.currentTarget
    if (button.classList.contains(addLoadingClass)) return

    const productCard = button.closest('.t4s-product')
    const productData = JSON.parse(productCard.getAttribute('data-product-options'))
    const link = productCard.querySelector('[data-pr-href]').getAttribute('href')
    const cachedId = 'lt-main-qa' + productData.id
    const flag = this.flag
    if (html_data[cachedId]) {
      T4SThemeSP.NTpopupInline(html_data[cachedId], 'lt-main-qa', n, 't4s-opening-qs')
      s.trigger('modalt4s:opened')
      regBtn(flag)
    } else {
      fetch(`${link}?section_id=lt-main-qa`)
        .then(function (e) {
          return e.text()
        })
        .then(function (o) {
          T4SThemeSP.NTpopupInline(o, 'lt-main-qa', n, 't4s-opening-qs')
          s.trigger('modalt4s:opened')
          regBtn(flag)
          html_data['lt-main-qa' + productData.id] = o
        })
        .finally(function () {
          button.classList.remove(addLoadingClass)
        })
    }
  }

  handleTextChange() {
    const count = this.selectedItems.length
    const oldPrice = this.selectedItems.reduce((total, item) => total + item.price, 0)
    let price = oldPrice
    let priceHtml = this.selectedTemp.querySelector('#select-0')
    if (count >= 4) {
      price *= (100 - this.discount4) / 100
    } else if (count === 3) {
      price *= (100 - this.discount3) / 100
      console.log('🚀 ~  this.discount3:',  this.discount3)
    }
    if (count >= 2) {
      priceHtml = this.selectedTemp.querySelector('#select-more')
    } else if (count === 1) {
      priceHtml = this.selectedTemp.querySelector('#select-1')
    }

    if (count > 0) {
      priceHtml.querySelector('.num').textContent = count
      priceHtml.querySelector('.price').textContent = T4SThemeSP.Currency?.formatMoney(price)
      priceHtml.querySelector('.price-origin').textContent =
        T4SThemeSP.Currency?.formatMoney(oldPrice)
    }

    if (count < 3) {
      priceHtml.querySelector('.price-origin') &&
        priceHtml.querySelector('.price-origin').classList.add('hidden')
    } else {
      priceHtml.querySelector('.price-origin').classList.remove('hidden')
    }
    if (this.selectedText) {
      this.selectedText.innerHTML = priceHtml.innerHTML
    }
  }

  handleDotChange() {
    const count = this.selectedItems.length
    this.steps.forEach((step, index) => {
      if (index < count) {
        step.classList.add('active')
      } else {
        step.classList.remove('active')
      }
    })

    if (count >= 4) {
      this.discountText.classList.add('active')
    } else {
      this.discountText.classList.remove('active')
    }

    if (count > 0) {
      this.addToCartButton.removeAttribute('disabled')
      this.addToCartButton.removeAttribute('aria-disabled')
    } else {
      this.addToCartButton.setAttribute('disabled', 'disabled')
      this.addToCartButton.setAttribute('aria-disabled', 'true')
    }
  }

  handleRemoveItem(e) {
    const button = e.target
    const id = button.closest('.swiper-slide').dataset.id
    const itemIndex = this.selectedItems.findIndex(item => item.eid === id)

    // Remove from selected items
    const removedItem = this.selectedItems[itemIndex]
    if (removedItem) {
      this.selectedItems.splice(itemIndex, 1)
      this.updateSection([itemIndex], 'remove')
    }
  }

  groupByQuantity(arr) {
    return Object.entries(
      arr.reduce((acc, curr) => {
        acc[curr] = (acc[curr] || 0) + 1
        return acc
      }, {})
    ).map(([id, quantity]) => ({ id: parseInt(id), quantity }))
  }

  handleAddToCart() {
    const items = this.groupByQuantity(this.selectedItems.map(item => String(item.id)))

    addStarProduct({ items }, () => {
      this.selectedItems = []
      this.updateSection()
    })
  }

  handleLoadMore(e) {
    // 加载更多功能
    e.preventDefault()

    this.loadMoreBtn.classList.add('is--loading')
    fetch(`${this.path}/page-${this.loadPage}?section_id=${this.sectionId}`)
      .then(res => res.text())
      .then(data => {
        const productListHtml = getSectionInnerHTML(data, 'goods_list')
        if (this.productContainer)
          this.productContainer.insertAdjacentHTML('beforeend', productListHtml)
        if (this.loadPage >= this.total) {
          this.loadMorePagination.remove()
        } else {
          this.currentPageEl.textContent = this.loadPage
          this.loadMoreBar.style.width = `${(this.loadPage / this.total) * 100}%`
        }
        this.loadPage++

        this.updateEvents()
      })
      .finally(() => {
        this.loadMoreBtn.classList.remove('is--loading')
      })
  }
}

// Initialize the section when the DOM is loaded
ltLazyLoad(function () {
  const sections = document.querySelectorAll('.bmsm-section')
  sections.forEach(section => {
    new BuyMoreSaveMore(section)
  })
})
